import React from 'react';
import ContentCreateWA from '../components/pages/waiting-area/createWA/content';
import { connect, useDispatch, useSelector } from 'react-redux';

const CreateWaitingAreaPage = (props) => {
  const createWAForm = useSelector((state) => state.waitingAreaReducer.createWAForm);
  const organisation = useSelector((state) => state.organisationsReducer.selectedOrgUnit);
  const showCreateWaitingAreaModal = useSelector((state) => state.modalReducer.showCreateWaitingAreaModal || false);
  const dispatch = useDispatch();

  return (
    <>
      <ContentCreateWA
        showCreateWaitingAreaModal={showCreateWaitingAreaModal}
        organisation={organisation}
        createWAForm={createWAForm}
        changeFilterValue={props.changeFilterValue}
        searchOnEntityPage={props.searchOnEntityPage}
        dispatch={dispatch}
      />
    </>
  );
};

export default CreateWaitingAreaPage;
